import { render, staticRenderFns } from "./PhysiotherapeuticWorkDiagnosis.vue?vue&type=template&id=3bf52c7e&"
import script from "./PhysiotherapeuticWorkDiagnosis.vue?vue&type=script&lang=js&"
export * from "./PhysiotherapeuticWorkDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports